var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84,8.1H16c-4.4,0-8,3.6-8,8V84c0,4.4,3.6,8,8,8h13.4c4.4,0,8-3.6,8-8V62.2c0-1.9-1.6-3.5-3.5-3.5H22.4L50,25.8l27.6,32.9  H66.1c-1.9,0-3.5,1.6-3.5,3.5V84c0,4.4,3.6,8,8,8H84c4.4,0,8-3.6,8-8V16C91.9,11.7,88.3,8.1,84,8.1z M89.6,84c0,3.1-2.5,5.6-5.6,5.6  H70.5c-3.1,0-5.6-2.5-5.6-5.6V62.2c0-0.6,0.5-1.2,1.2-1.2h14c1,0,1.5-1.2,0.9-1.9L50.9,23.2c-0.2-0.3-0.6-0.4-0.9-0.4  s-0.7,0.1-0.9,0.4L19,59.1c-0.6,0.8-0.1,1.9,0.9,1.9h14c0.6,0,1.2,0.5,1.2,1.2V84c0,3.1-2.5,5.6-5.6,5.6H16c-3.1,0-5.6-2.5-5.6-5.6  V16c0-3.1,2.5-5.6,5.6-5.6H84c3.1,0,5.6,2.5,5.6,5.6V84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgradeIcon.cd17b9bdf3194c864bb4689035dd9406.svg";
export { ForwardRef as ReactComponent };